export default "__VITE_ASSET__CyTxljsO__"